import { lzSAtomWithLocalStorage } from '@lz-store/services';

const lzSLayoutThemePaletteModeAtom = lzSAtomWithLocalStorage<'light' | 'dark'>('layoutThemePaletteModeState', 'light');

export default lzSLayoutThemePaletteModeAtom;
